// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__DwtSp","l1":"Loader_l1__Ir4sO"};